import React, { useCallback, useEffect } from 'react';
import { PLAYER_IFRAME_ID, EDITOR_QPLAYER_IDENTIFIER } from '../../../constants/scenarioConstant';
import { qplayerDomain } from '../../../utils/config';

const ScenarioEditorPlayerIframe = (props) => {
	const pause = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'pause' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const play = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'play' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const forward = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'forward' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const reward = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'reward' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const mute = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'mute' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const unMute = useCallback(() => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage({ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'unMute' }, 'https://play2.qbrick.com/');
		}
	}, []);

	const movePlayerToPosition = useCallback((pos, message = '') => {
		const playerIframe = document.getElementById(PLAYER_IFRAME_ID);
		if (playerIframe && playerIframe.contentWindow) {
			playerIframe.contentWindow.postMessage(
				{ identifier: EDITOR_QPLAYER_IDENTIFIER, type: 'move-position-from-editor', position: pos, message: message },
				'https://play2.qbrick.com/'
			);
		}
	}, []);

	useEffect(() => {
		props.movePlayerToPosition?.(movePlayerToPosition);
		props.pause?.(pause);
		props.play?.(play);
		props.forward?.(forward);
		props.reward?.(reward);
		props.mute?.(mute);
		props.unMute?.(unMute);
	}, [
		props.pause,
		props.play,
		props.forward,
		props.reward,
		props.movePlayerToPosition,
		props.mute,
		props.unMute,
		movePlayerToPosition,
		pause,
		play,
		forward,
		reward,
		mute,
		unMute,
	]);

	return (
		<iframe
			id={PLAYER_IFRAME_ID}
			src={`${qplayerDomain}?accountId=${props.accountId}&scenarioId=${props.scenarioId}&configId=Interactive&showBorder=true&fromSceneEditor=true`}
			frameBorder="0"
			border="0"
			height="100%"
			width="100%"
			style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none' }}
			allow="autoplay"
		/>
	);
};

export default ScenarioEditorPlayerIframe;
